// extracted by mini-css-extract-plugin
export default {"secondary-item":"qyi35","secondary-item--disabled":"lyBUE","bubble":"knkFo","basket-panel":"PQD_I","link-in-panel-title":"m1dJI"};